import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  ReactNode
} from 'react';
import { TestId } from '../abTestsConfig';
import { parseABCookies } from '../utils/helpers/abTest';

export type ABTestVariants = Record<string, string>;

const ABTestContext = createContext<ABTestVariants>({});

interface ABTestProviderProps {
  variants: ABTestVariants;
  children: ReactNode;
}

export const ABTestProvider = ({ variants, children }: ABTestProviderProps) => {
  const value = useMemo(() => {
    if (typeof window !== 'undefined') {
      return parseABCookies(document.cookie);
    }

    return variants;
  }, [variants]);

  return (
    <ABTestContext.Provider value={value}>{children}</ABTestContext.Provider>
  );
};

export const useABTest = (testId: TestId) => {
  const variants = useContext(ABTestContext);
  const variant = variants[testId] ?? null;
  const matchVariant = useCallback((id: string) => variant === id, [variant]);

  return { variant, matchVariant };
};
